

                if (!window.beaePageJS) {
                    window.beaePageJS = [];
                }
                let jsHandle_396mmxvxdo = () => {
                    
                        if (document.querySelector('.beae-f64bz8mx:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let e=window.innerWidth,t=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=e&&(e=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>t(),500)};t()}).call({
                                $el: document.querySelector('.beae-f64bz8mx:not([data-beae-bind])'),
                                
                                id: 'beae-f64bz8mx',
                                isLive: true
                            });
                            document.querySelector('.beae-f64bz8mx:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                }
                if (window.beaejQuery) {
                    jsHandle_396mmxvxdo()
                } else {
                    window.beaePageJS.push(jsHandle_396mmxvxdo)
                }
            